// Tazeen Hero Fix
// Directly sets CSS custom properties on the hero content wrapper
// to override Canyon's inline style attribute
document.addEventListener('DOMContentLoaded', function () {
  // Target the hero section content wrapper
  var hero = document.getElementById('Hero-hero_hRhTz6');
  if (!hero) return;

  var contentWrapper = hero.querySelector('.section-content-wrapper');
  if (contentWrapper) {
    // Override the CSS variables that Canyon sets via inline style
    contentWrapper.style.setProperty('--horizontal-alignment', 'flex-start');
    contentWrapper.style.setProperty('--vertical-alignment', 'flex-end');
    contentWrapper.style.setProperty('--vertical-alignment-mobile', 'flex-end');
    contentWrapper.style.maxWidth = '520px';
    contentWrapper.style.marginRight = 'auto';
    contentWrapper.style.paddingBottom = '64px';
    contentWrapper.style.paddingLeft = '52px';
  }

  var container = hero.querySelector('.hero__container');
  if (container) {
    container.style.setProperty('--horizontal-alignment', 'flex-start');
    container.style.setProperty('--vertical-alignment', 'flex-end');
    container.style.alignItems = 'flex-end';
    container.style.justifyContent = 'flex-start';
  }

  // Left-align all text
  var textEls = hero.querySelectorAll('h1, h2, h3, h4, p');
  textEls.forEach(function (el) {
    el.style.textAlign = 'left';
  });
});
